export default "<div class=\"wrapper login-wrapper\">\n    <router-outlet></router-outlet>\n</div>\n";